export var UserRole;
(function (UserRole) {
    UserRole["VIEWER"] = "VIEWER";
    UserRole["MANAGER"] = "MANAGER";
    UserRole["ADMIN"] = "ADMIN";
})(UserRole || (UserRole = {}));
export var UserOrgUnitRelationship;
(function (UserOrgUnitRelationship) {
    UserOrgUnitRelationship["WORKS_AT"] = "WORKS_AT";
    UserOrgUnitRelationship["SCOPE"] = "SCOPE";
})(UserOrgUnitRelationship || (UserOrgUnitRelationship = {}));
